import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getPublicCase } from "../api";
import type { CaseItem } from "../types";

export function CaseDetail() {
  const { slug = "" } = useParams();
  const [item, setItem] = useState<CaseItem | null>(null);
  const [error, setError] = useState("");
  useEffect(() => { getPublicCase(slug).then(setItem).catch((reason) => setError(reason.message)); }, [slug]);
  if (error) return <main className="detail-empty"><h1>案例未找到</h1><Link to="/">返回案例中心</Link></main>;
  if (!item) return <main className="detail-empty">正在加载案例…</main>;
  return <div className="public-shell">
    <header className="public-header"><Link to="/" className="brand">微会务 <span>案例中心</span></Link><Link to="/">全部案例</Link></header>
    <main className="case-detail">
      <div className="detail-heading"><p className="eyebrow">{item.kind.replace("_", " ")}</p><h1>{item.title}</h1><p>{item.summary}</p>
        <div className="tag-row">{item.keywords.map((tag) => <span key={tag}>{tag}</span>)}</div></div>
      {item.coverUrl && <img className="detail-cover" src={item.coverUrl} alt={`${item.title}案例封面`} />}
      <dl className="detail-facts">
        {item.clientName && <div><dt>客户</dt><dd>{item.clientName}</dd></div>}
        {item.eventDate && <div><dt>时间</dt><dd>{item.eventDate}</dd></div>}
        {item.location && <div><dt>地点</dt><dd>{item.location}</dd></div>}
      </dl>
      <article className="content-blocks">
        {item.blocks.map((block, index) => {
          if (block.type === "heading") return <h2 key={index}>{String(block.data.text || "")}</h2>;
          if (block.type === "paragraph") return <p key={index}>{String(block.data.text || "")}</p>;
          if (block.type === "image") return <img key={index} src={String(block.data.url || "")} alt={String(block.data.alt || item.title)} />;
          if (block.type === "quote") return <blockquote key={index}>{String(block.data.text || "")}</blockquote>;
          return null;
        })}
        {item.blocks.length === 0 && <p className="empty-panel">该历史案例正文正在整理，当前先保留原始案例资料与体验入口。</p>}
      </article>
      {item.qrUrl && <aside className="detail-qr"><img src={item.qrUrl} alt={`${item.title}体验二维码`} /><div><h2>扫码体验</h2><p>建议使用手机扫码打开，部分项目需要在指定 App 内运行。</p></div></aside>}
    </main>
  </div>;
}

